import { render } from "./InformationDocumentBlock.vue?vue&type=template&id=44873552&scoped=true&ts=true"
import script from "./InformationDocumentBlock.vue?vue&type=script&lang=ts"
export * from "./InformationDocumentBlock.vue?vue&type=script&lang=ts"

import "./InformationDocumentBlock.vue?vue&type=style&index=0&id=44873552&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44873552"]])

export default __exports__